export default __webpack_public_path__ + "static/media/PFSquareSansProLight_35485.a13ae5d4.ttf";